import * as mutationTypes from './mutation-types'

const namespaced = true

const initialState = () => ({
    auth: null,
    authError: null,
    connected: null,
    loading: false,
    authenticated: false
})

const state = initialState()

const getters = {
    auth: state => state.auth,
    isAuthed: state => state.authenticated,
    authError: state => state.authError,
    connected: state => state.connected,
    loading: state => state.loading
}

const actions = {
    resetWebsocket: async ({commit}) => commit(mutationTypes.RESET_WEBSOCKET),
    setAuth: async ({commit}, data) => {
        commit(mutationTypes.SET_WEBSOCKET_AUTH, data)
    }
}

const mutations = {
    [mutationTypes.RESET_WEBSOCKET]: state => Object.assign(state, initialState()),
    [mutationTypes.RESET_WEBSOCKET_AUTH] (state) {
        state.loading = false
        state.auth = null
        state.authError = null
    },
    [mutationTypes.SET_WEBSOCKET_AUTH] (state, data) {
        state.loading = true
        state.auth = data
    },
    [mutationTypes.SET_WEBSOCKET_AUTHENTICATED] (state, data) {
        state.authenticated = data
    },
    [mutationTypes.SET_WEBSOCKET_AUTH_ERROR] (state, data) {
        state.loading = false
        state.authError = data
    },
    [mutationTypes.SET_CONNECTED]: (state, data) => {
        state.connected = data
        if (state.connected) {
            state.authError = null
        }
    }
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
}
